export class AppInfo {
  public version = '25.9.26.493';
  public name: string = '';
  constructor() {
  }
}
